export enum CheckoutSteps {
	SelectDates = 1,
	SelectProduct = 2,
	SelectExtras = 3,
	PersonalDetails = 4,
	Payment = 5,
}
